"use client"

import { Card } from "react-bootstrap"
import { useTranslation } from "../../hooks/use-translation"
import { useAuth } from "../../contexts/auth-context"
import { useAppSelector } from "../../redux/hooks"

export default function MembershipCardPage() {
  const { user: authUser } = useAuth()
  const { users } = useAppSelector((state) => state.users)

  // Find the current user in the Redux store using their ID
  const user = authUser ? users.find((u) => u.id === authUser.id) || authUser : null

  const { t } = useTranslation()

  if (!user) return null

  return (
    <div className="py-3 mx-auto" style={{ maxWidth: "500px" }}>
      <h1 className="fs-2 fw-bold py-2 mb-4 text-white text-center">{t("membershipCard")}</h1>

      <Card className="overflow-hidden shadow-lg border-0" style={{ borderRadius: "24px" }}>
        <div
          className="text-white p-4 text-center position-relative d-flex flex-column justify-content-center"
          style={{
            background: "linear-gradient(135deg, #4F46E5 0%, #7C3AED 100%)",
            height: "280px",
          }}
        >
          <img
            src="/top-left.svg"
            alt=""
            className="position-absolute"
            style={{
              top: 0,
              left: 0,
              width: "120px",
              height: "120px",
              pointerEvents: "none",
            }}
          />
          <img
            src="/bottom-right.svg"
            alt=""
            className="position-absolute"
            style={{
              bottom: 0,
              right: 0,
              width: "120px",
              height: "120px",
              pointerEvents: "none",
            }}
          />

          <div className="position-relative" style={{ zIndex: 2 }}>
            <div className="mb-3 d-flex justify-content-center">
              {user.profilePhotoUrl ? (
                <img
                  src={user.profilePhotoUrl || "/placeholder.svg"}
                  alt={user.fullName}
                  className="rounded-circle"
                  style={{
                    width: "80px",
                    height: "80px",
                    objectFit: "cover",
                    objectPosition: "center",
                    border: "3px solid white",
                    display: "block",
                    minWidth: "80px",
                    minHeight: "80px",
                  }}
                />
              ) : (
                <div
                  className="rounded-circle bg-white d-flex align-items-center justify-content-center"
                  style={{
                    width: "80px",
                    height: "80px",
                    border: "3px solid white",
                  }}
                >
                  <span className="text-primary fw-bold" style={{ fontSize: "2rem" }}>
                    {user.fullName?.charAt(0)?.toUpperCase() || "U"}
                  </span>
                </div>
              )}
            </div>

            <div className="mb-2">
              <h1 className="fw-bold mb-1" style={{ fontSize: "2rem", letterSpacing: "2px" }}>
                {user.fullName || "USER"}
              </h1>
              <p className="mb-0" style={{ fontSize: "0.8rem", letterSpacing: "3px", opacity: 0.9 }}>
                SMART LIVING
              </p>
            </div>
          </div>
        </div>
      </Card>

      <div className="text-center mt-4 px-3">
        <p className="text-white" style={{ fontSize: "0.95rem", lineHeight: "1.5", opacity: 0.9 }}>
          {t("membershipCardDescription") ||
            "Present this card at any partner location to unlock your exclusive Unity discount."}
        </p>
      </div>
    </div>
  )
}
